export default {
      id: "icon-logo-impotant-usage",
      viewBox: "0 0 71 71",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-logo-impotant",
      toString: function () {
        return this.url;
      }
    }